<div class="main-content table-page table-page--compact configuracion-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Configuración</h1>
        <p>Todo lo que se ajusta una vez y se deja andando: la organización, quién ve qué, y los parámetros de cada módulo.</p>
      </div>
    </section>

    <div class="configuracion-page__grid" *ngIf="!vacia; else sinTarjetas">
      <section class="configuracion-page__seccion" *ngFor="let seccion of secciones">
        <h2 class="configuracion-page__titulo">{{ seccion.titulo }}</h2>
        <a class="configuracion-page__tarjeta" *ngFor="let tarjeta of seccion.tarjetas" [routerLink]="tarjeta.ruta">
          <span class="configuracion-page__icono material-icons">{{ tarjeta.icono }}</span>
          <span class="configuracion-page__texto">
            <strong>{{ tarjeta.titulo }}</strong>
            <small *ngIf="tarjeta.descripcion">{{ tarjeta.descripcion }}</small>
          </span>
          <span class="material-icons configuracion-page__chevron">chevron_right</span>
        </a>
      </section>
    </div>

    <ng-template #sinTarjetas>
      <section class="table-page__card">
        <div class="table-page__empty">
          <span class="material-icons">settings</span>
          <h3>No tiene pantallas de configuración</h3>
          <p>Su perfil no incluye ninguna. Si necesita alguna, pídala a quien administra los perfiles.</p>
        </div>
      </section>
    </ng-template>
  </div>
</div>
